import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authservices } from '../../APIServices/AuthService';

// Async thunk to fetch user entitlement
export const fetchUserEntitlement = createAsyncThunk(
  'userEntitlement/fetchUserEntitlement',
  async (_, { rejectWithValue }) => {
    try {
      const response = await authservices.getUserEntitlement();
      return response.data?.data ?? response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const userEntitlementSlice = createSlice({
  name: 'userEntitlement',
  initialState,
  reducers: {
    clearEntitlement: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserEntitlement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserEntitlement.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchUserEntitlement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearEntitlement } = userEntitlementSlice.actions;
export default userEntitlementSlice.reducer;

